import React, { useEffect, useState, createContext, useContext } from 'react';
const TOTAL_STOCK = 100;
const STORAGE_KEY = 'misery_sold_count';
function getInitialSold(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return Math.min(parseInt(stored, 10), TOTAL_STOCK);
  } catch {}
  return 35;
}
interface StockContextType {
  sold: number;
  available: number;
  total: number;
  percentSold: number;
  recordPurchase: () => void;
}
const StockContext = createContext<StockContextType>({
  sold: 35,
  available: 65,
  total: TOTAL_STOCK,
  percentSold: 35,
  recordPurchase: () => {}
});
export function StockProvider({
  children
}: {
  children: ReactNode;
}) {
  const [sold, setSold] = useState(getInitialSold);
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(sold));
    } catch {}
  }, [sold]);
  const recordPurchase = () => {
    setSold(prev => Math.min(prev + 1, TOTAL_STOCK));
  };
  const available = TOTAL_STOCK - sold;
  const percentSold = Math.round(sold / TOTAL_STOCK * 100);
  return <StockContext.Provider value={{
    sold,
    available,
    total: TOTAL_STOCK,
    percentSold,
    recordPurchase
  }} data-id="element-110">
      {children}
    </StockContext.Provider>;
}
export function useStock() {
  return useContext(StockContext);
}